import { render, staticRenderFns } from "./DashboardReportGroupProduct.vue?vue&type=template&id=3e5fd2bf&scoped=true"
import script from "./DashboardReportGroupProduct.vue?vue&type=script&lang=js"
export * from "./DashboardReportGroupProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5fd2bf",
  null
  
)

export default component.exports